import { upperFirst, lowerCase } from "lodash";

import { IEventGuestStatus } from "Bands/types";
import { Checkmark, Stop, Clock } from "shared/assets/icons";
import { getStatus } from "shared/styles/defaults";
import { IStatus } from "shared/types";

export const getGuestStatus = (guestStatus: IEventGuestStatus) => {
  let icon = Checkmark;
  let status = IStatus.success;
  const label = getGuestStatusLabel(guestStatus);

  switch (guestStatus) {
    case IEventGuestStatus.denied:
      icon = Stop;
      status = IStatus.error;
      break;
    case IEventGuestStatus.pending:
      icon = Clock;
      status = IStatus.warning;
      break;
  }

  return {
    icon,
    status,
    label,
    textColor: getStatus(status).textColor,
    iconColor: getStatus(status).iconColor,
  };
};

const getGuestStatusLabel = (guestStatus: IEventGuestStatus) => {
  // Could be changed to a switch statement when case specific logic is needed
  // But right now the api call returns lowercased string values
  return upperFirst(lowerCase(guestStatus));
};
